import React from "react"
import { useTranslation } from "react-i18next"

import { TextInput } from "shared/ui/input/text/TextInput"

import { useRoomFormContext } from "../../contexts/RoomFormContext"

const MAX_LENGTH_ROOM_NUMBER = 20

export interface RoomNumberInputProps {
  hideLabel?: boolean
  autoFocus?: boolean
}

export const RoomNumberInput = React.memo(
  ({ hideLabel, autoFocus }: RoomNumberInputProps) => {
    const { t } = useTranslation()
    const { isReadonly, isDisabled } = useRoomFormContext()

    return (
      <TextInput.Root
        name="room.number"
        className="room-form__number"
        label={t("Room.number")}
        maxLength={MAX_LENGTH_ROOM_NUMBER}
        autoFocus={autoFocus}
        readonly={isReadonly}
        disabled={isDisabled}
        required
      >
        {!hideLabel ? <TextInput.Label /> : null}
        <TextInput.Focus>
          <TextInput.Input type="text" data-testid="room__number__input" />
          <TextInput.Counter />
        </TextInput.Focus>
        <TextInput.Readonly />
        <TextInput.ErrorMessage />
      </TextInput.Root>
    )
  }
)
